import styled from 'styled-components';
import logo from 'assets/logos/logo.svg';
import { Divider as DividerAntd } from 'antd';
import openInNew from 'assets/svgs/openInNew.svg';
import contentCopy from 'assets/svgs/contentCopy.svg';
import vhLogo from 'assets/logos/vhLogo.svg';
import vhLogoLarge from 'assets/logos/vhLogoLarge.svg';
import captivePortal from 'assets/svgs/captivePortal.svg';
import socialFb from 'assets/svgs/socialFb.svg';
import socialIg from 'assets/svgs/socialIg.svg';
import { BREAKPOINTS } from 'constants/Global/Breakpoints.const';

export const Root = styled.footer`
  display: block;
  background-color: #f78e1e;
  color: transparent;
  text-decoration: none;

  > div {
    height: 100%;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: fit-content;
  row-gap: 16px;
  padding: 16px;
  padding-bottom: 30px;

  @media (min-width: ${BREAKPOINTS.tabletMini}) {
    padding: 16px 24px 24px;
  }

  @media (min-width: ${BREAKPOINTS.tablet}) {
    padding: 16px 32px 32px;
  }
`;

export const Icon = styled.a`
  display: block;
  background-position: top center;
  background-repeat: no-repeat;
  background-size: contain;
  color: transparent;
  text-decoration: none;
`;

export const Logo = styled(Icon)`
  width: 96px;
  height: 48px;
  background-image: url(${logo});

  @media (min-width: ${BREAKPOINTS.tablet}) {
    width: 128px;
    height: 64px;
  }
`;

export const ColumnList = styled.div`
  @media (min-width: 600px) {
    display: grid;
    column-gap: 16px;
    row-gap: 16px;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(2, 1fr);
  }

  @media (min-width: ${BREAKPOINTS.tablet}) {
    column-gap: 16px;
    row-gap: 16px;
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: 1fr;
  }

  @media (min-width: ${BREAKPOINTS.desktop}) {
    column-gap: 24px;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;

  &:last-of-type div:last-of-type {
    margin-bottom: 0;
  }
`;

export const ColumnItem = styled.div`
  display: flex;
  align-items: center;
  column-gap: 10px;
  margin: 8px 0;
`;

export const ColumnTitle = styled(ColumnItem)`
  > span {
    font-size: 0.625rem;
    font-weight: bold;
  }
`;

export const Link = styled.a`
  display: flex;
  align-items: center;
  column-gap: 10px;
`;

export const Text = styled.span<{ $small?: boolean; $bold?: boolean }>`
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: ${({ $small }) => ($small ? '0.625rem' : '0.875rem')};
  color: #fff;
  text-align: start;
  white-space: break-spaces;
`;

export const Bold = styled.span`
  font-weight: bold;
`;

export const Divider = styled(DividerAntd)`
  background: #fff;
  margin: 0;
`;

export const OpenInNew = styled(Icon)`
  width: 10px;
  height: 10px;
  background-image: url(${openInNew});
`;

export const ContentCopy = styled(Icon)`
  width: 10px;
  height: 12px;
  background-image: url(${contentCopy});
`;

export const VhLogo = styled(Icon)`
  width: 28px;
  height: 32px;
  background-image: url(${vhLogo});
  margin-top: 12px;
  margin-left: 6px;

  @media (min-width: ${BREAKPOINTS.tabletMini}) {
    margin-top: 0;
    margin-right: 22px;
  }

  @media (min-width: ${BREAKPOINTS.tablet}) {
    width: 118px;
    background-image: url(${vhLogoLarge});
    margin-right: 16px;
    margin-left: 0;
  }
`;

export const BottomFooter = styled.div`
  @media (min-width: 600px) {
    display: flex;
    align-items: center;
    padding-top: 8px;
  }
`;

export const Address = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 4px;
  margin-top: 16px;
  margin-bottom: 22px;

  @media (min-width: ${BREAKPOINTS.tabletMini}) {
    margin-top: 0;
    margin-bottom: 0;
  }

  > span {
    font-size: 0.75rem;
  }
`;

export const Socials = styled.div`
  display: flex;
  align-items: center;
  column-gap: 26px;

  @media (min-width: ${BREAKPOINTS.tabletMini}) {
    margin-left: auto;
  }

  a {
    width: 20px;
    height: 20px;
  }
`;

export const CaptivePortal = styled(Icon)`
  background-image: url(${captivePortal});
`;

export const SocialFb = styled(Icon)`
  background-image: url(${socialFb});
`;

export const SocialIg = styled(Icon)`
  background-image: url(${socialIg});
`;
